/* istanbul ignore file */
import { faWandMagicSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { DescriptionContainer, DescriptionText, Header, HeaderContainer, SubHeader } from './index';

export function StepDescription({ stepKey, descriptionKey }: Readonly<{ stepKey: string; descriptionKey?: string }>) {
  const { t } = useTranslation('createProduct');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <DescriptionContainer>
      <HeaderContainer>
        <FontAwesomeIcon icon={faWandMagicSparkles} size={isMobile ? '2x' : '3x'} />
        <Header>{t('pageTitle')}</Header>
      </HeaderContainer>
      <SubHeader>{t(stepKey)}</SubHeader>
      {descriptionKey && (
        <Trans>
          <DescriptionText>{t(descriptionKey)}</DescriptionText>
        </Trans>
      )}
    </DescriptionContainer>
  );
}
